module.exports = __webpack_public_path__ + "img/vodka-martini.68fd6b4c.jpg";